<template>
  <div class="checkout-information">
    <div class="event-image">
      <img v-if="conference.id === 2278" :src="conference.event_logo_url" alt="Event Registration Image" />

      <img v-else :src="conference.landing_page_bg_url" alt="Event Registration Image" />
    </div>

    <div class="modal-body">
      <div class="order-summary-wrapper">
        <h5 class="order-summary-title">
          <span>Order Summary</span>

          <button
            class="btn btn-xs btn-secondary"
            :class="{'btn-clear': !isWidget}"
            @click="onClearBasket"
            :disabled="showIndicator || !(order?.history?.length && step !== '4')"
          >
            <i class="fa-regular fa-remove"></i> Clear
          </button>
        </h5>

        <!-- Orders -->
        <div class="orders">
          <fragment
            v-for="(orderItem, orderIndex) in order.history"
            :key="`order-${orderIndex}`"
          >
            <div
              v-for="(ticketItem, ticketIndex) in orderItem.history"
              :key="`order-${ticketIndex}`"
              class="order-item"
              :class="{ 'order-item-discount': ticketItem.type === 'discount', 'order-item-addon': (ticketItem.type === 'addon' || ticketItem.type === 'donation') }"
            >
              <div class="order-info" :class="{ 'text-danger': ticketItem.type === 'discount', 'text-primary': (ticketItem.type === 'addon' || ticketItem.type === 'donation') }">
                {{ ticketItem.name }}
              </div>
              <div v-if="ticketItem.type === 'discount'" class="price-value text-danger">
                - {{ currencySymbol }}{{ ticketItem.price | toFixed }}
              </div>
              <div v-else class="price-value" :class="{ 'text-primary': (ticketItem.type === 'addon' || ticketItem.type === 'donation') }">
                {{ currencySymbol }}{{ ticketItem.price | toFixed }}
              </div>
            </div>
          </fragment>
        </div>

        <hr />

        <div v-if="settings.donation_enabled" class="donation-wrapper">
          {{ settings.donation_title }}
          <input
            id="donation"
            class="form-control"
            type="text"
            name="donation"
            v-model="donation"
            :disabled="step !== '1'"
            @input="updateDonation"
          />
        </div>

        <div class="total-price-wrapper order-item">
          <div class="price-value">Total</div>
          <div class="total-price">{{ currencySymbol }}{{ order.summary.total_price | toFixed }}</div>
        </div>
      </div>

      <div class="addons-summary-wrapper" v-if="showAddonsSummary && step === '2'">
        <div class="addons-summary-title">Add-on's Left to Assign:</div>
        <div class="session-addons-wrapper">
          Session Add-on: <span class="session-addons-quantity">{{sessionAddonsQuantity}}</span>
        </div>
        <div class="item-addons-wrapper">
          Item Add-on: <span class="item-addons-quantity">{{itemAddonsQuantity}}</span>
        </div>
      </div>

      <div v-if="conference.id === 7007">
        <small>
          If you have entered your email address associated with your ACES membership and the price is not updating to your membership discount, please reach out to <a href="mailto:acesconference@acesonline.net" target="_blank" style="color: rgb(59, 100, 173); font-weight: 600;">acesconference@acesonline.net</a>
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { toFixed } from "../../helpers/filters";

export default {
  props: {
    isWidget: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    toFixed
  },
  computed: {
    ...mapGetters("basketStore", [
      "conference",
      "settings",
      "order",
      "step",
      "currencySymbol",
      "isFetching",
      "showIndicator",
      "slug",
      "showAddonsSummary",
      "totalSessionAddons",
      "totalItemAddons",
      "selectedSessionAddons",
      "selectedItemAddons",
      "donation",
    ]),

    sessionAddonsQuantity() {
      return (+this.totalSessionAddons - +this.selectedSessionAddons);
    },

    itemAddonsQuantity() {
      return (+this.totalItemAddons - +this.selectedItemAddons);
    }
  },
  methods: {
    ...mapActions('basketStore', ['clearBasket']),

    updateDonation(event) {
      this.$store.commit('basketStore/updateDonation', event.target.value);
    },

    onClearBasket() {
      this.clearBasket({slug: this.slug})
        .then(() => {
          // go to next step
          this.$store.dispatch('basketStore/changeStep', { type: "set", step: "1" });
          // close all accordions for addons
          $('.addons-collapse').collapse('hide');
        })
        .finally(() => {});
    }
  }
}
</script>

<style lang="scss" scoped>
.order-summary-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-clear {
  margin-right: 45px;
}
</style>